<div class="dialog-main-container">
  <div class="header-container">
    <div class="section-info-container">
      <div class="title">{{ dialogTitle }}</div>
      <div class="section-info">{{ dialogDescription }}</div>
    </div>
  </div>

  <div class="dialog-content">
    <div class="dialog-body">
      <div class="dialog-section">
        <div class="section-info-container">
          <div class="section-title">Language</div>
          <div class="section-info">Select which language version to preview.</div>
        </div>
        <div style="width: 266px">
          <ag-drop-down [list]="languageList" [showSearchField]="false" [currentValue]="currentLanguage" (changedValue)="currentLanguage = $event"></ag-drop-down>
        </div>
      </div>

      <div class="dialog-section">
        <div class="section-info-container">
          <div class="section-title">Version</div>
          <div class="section-info">Select if the preview and download should be draft or published template.</div>
        </div>
        <div style="width: 266px">
          <ag-toggle-button option1="Draft" option2="Published" [widthPerOption]="128" [notSelectedDisable]="!isPublished" [numberOfOptions]="2" initValue="Draft" (chosenOption)="changeVersion($event)"></ag-toggle-button>
        </div>
      </div>

      <div *ngIf="previewMode" class="section-info-container preview-section">
        <div class="section-title">Preview</div>
        <div id="canvas-preview-container" class="preview-container"></div>
      </div>
    </div>
  </div>

  <div class="bottom-wrapper">
    <div style="margin: 0 -24px">
      <bar-loader height="2px" heightGreyBar="1px" [isLoading]="loading"></bar-loader>
    </div>
    <div class="buttons-container">
      <ag-button-v2 [disabled]="loading" label="Preview" type="secondary" (click)="seePreview()"></ag-button-v2>
      <ag-button-v2 [disabled]="loading" label="Cancel" type="secondary" (click)="closeDialog()"></ag-button-v2>
      <ag-button-v2 [disabled]="loading" label="Confirm" type="primary" (click)="submitQuickAction()"></ag-button-v2>
    </div>
  </div>
</div>
